import { render, staticRenderFns } from "./ModalSendNotes.vue?vue&type=template&id=86f94e0e&"
import script from "./ModalSendNotes.vue?vue&type=script&lang=js&"
export * from "./ModalSendNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports